<template>
  <div class="ts-app-shell_fh">
    <div class="ts-app-landing-dashboard">
      <div class="padd-main ts-wioa">
        <el-row class="narrow">
          <el-col>
            <h5 class="dashboard-title">WIOA Checklist</h5>
          </el-col>
        </el-row>
        <el-row class="narrow">
          <el-col class="dashboard-paragraph">
            <span style="font-size: 12px;"
              >View responses from your complete WIOA Checklist</span
            >
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-form @submit.native.prevent>
          <el-form-item :required="true" v-if="checklistDetails != null">
            <div class="ts-comp--multiselect columned">
              <div class="ts-comp--multiselect-item">
                <label class="header-label" role="title"
                  ><strong>Questions</strong></label
                >
                <div class="cols header-cols">
                  <span class="response">
                    <strong>Response</strong>
                  </span>
                  <span class="documentsUploaded">
                    <strong>Documents Uploaded</strong>
                  </span>
                  <span class="uploadCaseNotes">
                    <strong
                      >Upload Document <br />
                      Upload Case Notes
                    </strong>
                  </span>
                  <span class="documentsHeldOnFile">
                    <strong
                      >Documents <br />
                      held on file
                    </strong>
                  </span>
                  <span class="Verified">
                    <strong>Manager Verified</strong>
                  </span>
                  <span class="DesignatedStaff">
                    <strong
                      >Designated Staff<br />
                      Member/s Verified
                    </strong>
                  </span>
                </div>
              </div>
              <div
                v-for="(item, index) in checklistDetails.checklist
                  .eligibilityCriteria"
                :key="`eligibility-${index}`"
                class="ts-comp--multiselect-item"
              >
                <label
                  class="activity-label"
                  v-if="index == 'authorizedToWork'"
                >
                  Authorized to Work in the United States
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'authorizedToWork'"
                >
                  <span class="response">
                    {{ item.isAuthorizedToWork == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'birthDate'">
                  What is your birth date?
                </label>
                <div class="cols header-cols" v-if="index == 'birthDate'">
                  <span class="response">
                    {{ item.clientBirthDate | moment("MMMM DD, YYYY") }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'selectiveServiceRegistration'"
                >
                  Selective Service Registration?
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'selectiveServiceRegistration'"
                >
                  <span class="response">
                    {{
                      item.isSelectiveServiceRegistered == true ? "Yes" : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
              </div>
              <div
                v-for="(item, index) in checklistDetails.checklist
                  .adultServicePriority"
                :key="`eligibility-${index}`"
                class="ts-comp--multiselect-item"
              >
                <label
                  class="activity-label"
                  v-if="index == 'individualIncome'"
                >
                  What is your individual income?
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'individualIncome'"
                >
                  <span class="response">
                    {{ item.income }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'familyIncome'">
                  What is your family household income?
                </label>
                <div class="cols header-cols" v-if="index == 'familyIncome'">
                  <span class="response">
                    {{ item.income }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'individualOrFamily'"
                >
                  Individual/Family Size?
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'individualOrFamily'"
                >
                  <span class="response">
                    {{ item.isIndividual == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'tanf'">
                  Recipient of TANF?
                </label>
                <div class="cols header-cols" v-if="index == 'tanf'">
                  <span class="response">
                    {{ item.isRecipientOfTANF == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'snap'">
                  Recipient of SNAP?
                </label>
                <div class="cols header-cols" v-if="index == 'snap'">
                  <span class="response">
                    {{ item.isRecipientOfSNAP == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'ssdi'">
                  Recipient of SSI/SSDI?
                </label>
                <div class="cols header-cols" v-if="index == 'ssdi'">
                  <span class="response">
                    {{ item.isRecipientOfSSDI == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'ga'">
                  Recipient of GA?
                </label>
                <div class="cols header-cols" v-if="index == 'ga'">
                  <span class="response">
                    {{ item.isRecipientOfGA == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'rca'">
                  Recipient of RCA?
                </label>
                <div class="cols header-cols" v-if="index == 'rca'">
                  <span class="response">
                    {{ item.isRecipientOfRCA == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'homeless'">
                  Homeless
                </label>
                <div class="cols header-cols" v-if="index == 'homeless'">
                  <span class="response">
                    {{ item.isHomeless == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'recipientOfFreeLunch'"
                >
                  Recipient of free school lunches?
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'recipientOfFreeLunch'"
                >
                  <span class="response">
                    {{ item.isRecipientOfFreeLunch == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'fosterCare'">
                  Foster Care?
                </label>
                <div class="cols header-cols" v-if="index == 'fosterCare'">
                  <span class="response">
                    {{ item.isFosterCare == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'individualWithDisability'"
                >
                  Individual with Disability?
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'individualWithDisability'"
                >
                  <span class="response">
                    {{ item.isDisabled == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'basicSkillsDeficient'"
                >
                  Basic Skills Deficient?
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'basicSkillsDeficient'"
                >
                  <span class="response">
                    {{ item.isSkillsDeficient == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
              </div>
              <div
                v-for="(item, index) in checklistDetails.checklist
                  .dislocatedWorker.categoryOne"
                :key="`eligibility-${index}`"
                class="ts-comp--multiselect-item"
              >
                <label
                  class="activity-label"
                  v-if="index == 'employmentTerminated'"
                >
                  Employment Terminated / Laid Off
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'employmentTerminated'"
                >
                  <span class="response">
                    {{ item.isEmploymentTerminated == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'uIBenefits'">
                  Eligible for UI Benefits
                </label>
                <div class="cols header-cols" v-if="index == 'uIBenefits'">
                  <span class="response">
                    {{ item.isEligibleForUIBenefit == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'unemploymentBenefits'"
                >
                  Uneligible for Unemployment Benefits
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'unemploymentBenefits'"
                >
                  <span class="response">
                    {{
                      item.isIneligibleUnemploymentBenefits == true
                        ? "Yes"
                        : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'previousOccupation'"
                >
                  Unlikely To Return To Previous Occupation
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'previousOccupation'"
                >
                  <span class="response">
                    {{
                      item.isUnlikelyToReturnToPreviousOccupation == true
                        ? "Yes"
                        : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'militaryService'">
                  Separated From Military Service
                </label>
                <div class="cols header-cols" v-if="index == 'militaryService'">
                  <span class="response">
                    {{
                      item.isSeparatedFromMilitaryService == true ? "Yes" : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
              </div>
              <div
                v-for="(item, index) in checklistDetails.checklist
                  .dislocatedWorker.categoryTwo"
                :key="`eligibility-${index}`"
                class="ts-comp--multiselect-item"
              >
                <label class="activity-label" v-if="index == 'unemployed'">
                  Unemployed Due To Closure
                </label>
                <div class="cols header-cols" v-if="index == 'unemployed'">
                  <span class="response">
                    {{ item.isUnemployedDueToClosure == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'closure'">
                  Notified of Planned Closure
                </label>
                <div class="cols header-cols" v-if="index == 'closure'">
                  <span class="response">
                    {{ item.isNotifiedOfClosure == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'notifed'">
                  Notified By General Announcement
                </label>
                <div class="cols header-cols" v-if="index == 'notifed'">
                  <span class="response">
                    {{
                      item.isNotifiedByGeneralAnnouncement == true
                        ? "Yes"
                        : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
              </div>
              <div
                v-for="(item, index) in checklistDetails.checklist
                  .dislocatedWorker.categoryThree"
                :key="`eligibility-${index}`"
                class="ts-comp--multiselect-item"
              >
                <label class="activity-label" v-if="index == 'selfEmployed'">
                  Previously Self Employed
                </label>
                <div class="cols header-cols" v-if="index == 'selfEmployed'">
                  <span class="response">
                    {{ item.isPreviouslySelfEmployed == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'presentlyUnemployed'"
                >
                  Presently Unemployed
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'presentlyUnemployed'"
                >
                  <span class="response">
                    {{ item.isPresentlyUnemployed == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'permanentlyDislocated'"
                >
                  Permanently Dislocated
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'permanentlyDislocated'"
                >
                  <span class="response">
                    {{ item.isPermanentlyDislocated == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
              </div>
              <div
                v-for="(item, index) in checklistDetails.checklist
                  .dislocatedWorker.categoryFour"
                :key="`eligibility-${index}`"
                class="ts-comp--multiselect-item"
              >
                <label class="activity-label" v-if="index == 'unpaidServices'">
                  Providing Unpaid Services to Family
                </label>
                <div class="cols header-cols" v-if="index == 'unpaidServices'">
                  <span class="response">
                    {{ item.isProvidingUnpaidServices == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'employment'">
                  Experiencing Difficulty in Employment
                </label>
                <div class="cols header-cols" v-if="index == 'employment'">
                  <span class="response">
                    {{
                      item.isExperiencingDifficultyObtainingEmployment == true
                        ? "Yes"
                        : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'dependentOnIncome'"
                >
                  Dependent on Income of Family Member
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'dependentOnIncome'"
                >
                  <span class="response">
                    {{
                      item.isDependentOnIncomeOfAnotherFamilyMember == true
                        ? "Yes"
                        : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'dependentSpouse'">
                  Dependent Spouse of a Member of Armed Forces
                </label>
                <div class="cols header-cols" v-if="index == 'dependentSpouse'">
                  <span class="response">
                    {{
                      item.isDependentSpouseOfAMemberOfArmedForces == true
                        ? "Yes"
                        : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
              </div>
              <div
                v-for="(item, index) in checklistDetails.checklist
                  .dislocatedWorker.categoryFive"
                :key="`eligibility-${index}`"
                class="ts-comp--multiselect-item"
              >
                <label
                  class="activity-label"
                  v-if="index == 'armedForcesLossEmployment'"
                >
                  Spouse of a Armed Forces Who Loss Employment
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'armedForcesLossEmployment'"
                >
                  <span class="response">
                    {{
                      item.isSpouseOfAMemberOfArmedForcesLossEmployment == true
                        ? "Yes"
                        : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label
                  class="activity-label"
                  v-if="index == 'armedForcesUnemployed'"
                >
                  Spouse of a Armed Forces Whose Unemployed
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'armedForcesUnemployed'"
                >
                  <span class="response">
                    {{
                      item.isSpouseOfAMemberOfArmedForcesUnemployed == true
                        ? "Yes"
                        : "No"
                    }}
                  </span>
                  <span class="documentsUploaded">
                    <div
                      v-for="(document, index) in item.clientFiles"
                      :key="`document-${index}`"
                      style="text-overflow: ellipsis; overflow: hidden;"
                    >
                      <span
                        @click="showDocument(document)"
                        style="cursor: pointer; color: #00cce6;"
                      >
                        {{ document.fileName }}
                      </span>
                    </div>
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
              </div>
              <div
                v-for="(item, index) in checklistDetails.checklist.confirmation"
                :key="`eligibility-${index}`"
                class="ts-comp--multiselect-item"
              >
                <label
                  class="activity-label"
                  v-if="index == 'answersConfirmed'"
                >
                  Answers Confirmed
                </label>
                <div
                  class="cols header-cols"
                  v-if="index == 'answersConfirmed'"
                >
                  <span class="response">
                    {{ item.isCompleted == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
                <label class="activity-label" v-if="index == 'reviewConfirmed'">
                  Review Confirmed
                </label>
                <div class="cols header-cols" v-if="index == 'reviewConfirmed'">
                  <span class="response">
                    {{ item.isUploadedDocumentsValid == true ? "Yes" : "No" }}
                  </span>
                  <span class="documentsUploaded">
                    N/A
                  </span>
                  <span class="uploadCaseNotes">
                    <el-upload
                      v-if="item.caseWorkerFileId == null"
                      action=""
                      class="upload-icon"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="fa fa-upload" />
                    </el-upload>
                    <span v-else> sample docs uploaded</span>
                  </span>
                  <span class="documentsHeldOnFile">
                    <el-checkbox v-model="item.isDocsHeldOnFile"></el-checkbox>
                  </span>
                  <span class="Verified">
                    <el-checkbox
                      v-model="item.isVerified"
                      disabled
                    ></el-checkbox>
                  </span>
                  <span class="DesignatedStaff">
                    <figure class="ts-profile-img small">
                      <span v-if="item.designatedStaffName != null">
                        <img
                          v-bind:src="
                            'https://ui-avatars.com/api/?name=' +
                              `${item.designatedStaffName}` +
                              '&background=14223C&color=fff'
                          "
                          style="width: 100%"
                          :alt="item.designatedStaffName"
                        />
                      </span>
                    </figure>
                  </span>
                </div>
              </div>
            </div>
          </el-form-item>
          <br /><br />
          <el-row>
            <el-button
              class="btn-details ts-btn-secondary wide"
              @click="gotoIndex"
            >
              Home
            </el-button>
          </el-row>
        </el-form>
      </div>
    </div>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";
import { BucketType } from "@/enums";

export default {
  components: { TSLoading },
  data() {
    return {
      loading: false,
      checklistId: null,
      checklistDetails: null,
      yesNoOptions: [
        { value: true, label: "Yes" },
        { value: false, label: "No" }
      ],
      yesNoUnsureOptions: [
        { value: 0, label: "Yes" },
        { value: 1, label: "No" },
        { value: 2, label: "Unsure" }
      ]
    };
  },
  computed: {},
  created() {
    debugger;
    this.checklistId = this.$route.params.checklistId;
    this.loading = true;
    this.$store
      .dispatch("wioa/getChecklistToReview", this.checklistId)
      .then(res => {
        debugger;
        this.checklistDetails = res;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    gotoIndex() {
      this.$router.push({ name: "EligibilityDashboard" });
    },
    showDocument(item) {
      debugger;
      this.loading = true;
      this.$store
        .dispatch("common/getImage", {
          objectId: item.fileId,
          bucketType: BucketType.WioaChecklist
        })
        .then(result => {
          debugger;
          // const blob = new Blob([result], { type: "image/png" });
          const link = document.createElement("a");
          link.href = result;
          link.target = "_blank";
          link.download = "test";
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style lang="scss" scoped>
.wide {
  width: 250px;
  margin-top: 10px;
  color: white;
}

.ts-profile-img {
  position: relative;
  width: 35px;
  height: 35px;
  border-radius: 45px;
  overflow: hidden;
  margin: auto;
}

.uploadCaseNotes,
.documentsHeldOnFile,
.Verified,
.DesignatedStaff {
  display: none !important;
}

.ts-comp--multiselect.columned .ts-comp--multiselect-item .cols > span {
  border: none !important;
}
</style>
